module.exports = __webpack_public_path__ + "img/pic-2.40eea538.png";